<template>
  <div class="relative">
    <transition name="fadeIn">
      <div
        class="drawer-backdrop"
        v-if="labelsOpen"
        @click.self="labelsOpen = false"
      ></div>
    </transition>
    <transition name="slideFromRight">
      <div class="drawer" v-if="labelsOpen">
        <!-- Header -->
        <div class="drawer__header">
          <div class="drawer__header-content">
            <h3 class="drawer__title">{{ $t('Customize labels') }}</h3>
            <p class="drawer__subtitle">{{ $t('Organize your changelog entries') }}</p>
          </div>
          <button
            type="button"
            @click.prevent="labelsOpen = false"
            class="drawer__close"
            :title="$t('Close')"
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <!-- Body -->
        <div class="drawer__body">
          <p class="text-sm text-neutral-600 mb-4">
            {{ $t('Use labels to categorize different kinds of updates.') }}
          </p>

          <div class="drawer__list">
            <template v-for="label in allLabels">
              <Label
                :original-label="label"
                :key="label.id"
                @destroyedLabel="removeLabel($event)"
                @updatedLabel="updateLabel($event)"
              ></Label>
            </template>
            <NewLabel @newLabel="addLabel($event)"></NewLabel>
          </div>
        </div>
      </div>
    </transition>

    <button
      type="button"
      class="inline-flex items-center gap-1.5 text-xs font-medium text-neutral-600 hover:text-neutral-800 transition-colors"
      @click.prevent="labelsOpen = !labelsOpen"
    >
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-3.5 h-3.5">
        <path stroke-linecap="round" stroke-linejoin="round" d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 0 1 1.37.49l1.296 2.247a1.125 1.125 0 0 1-.26 1.431l-1.003.827c-.293.24-.438.613-.43.992a7.723 7.723 0 0 1 0 .255c-.008.378.137.75.43.991l1.004.827c.424.35.534.955.26 1.43l-1.298 2.247a1.125 1.125 0 0 1-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.47 6.47 0 0 1-.22.128c-.331.183-.581.495-.644.869l-.213 1.281c-.09.543-.56.94-1.11.94h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 0 1-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 0 1-1.369-.49l-1.297-2.247a1.125 1.125 0 0 1 .26-1.431l1.004-.827c.292-.24.437-.613.43-.991a6.932 6.932 0 0 1 0-.255c.007-.38-.138-.751-.43-.992l-1.004-.827a1.125 1.125 0 0 1-.26-1.43l1.297-2.247a1.125 1.125 0 0 1 1.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.087.22-.128.332-.183.582-.495.644-.869l.214-1.281Z" />
        <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
      </svg>
      {{ $t('Customize') }}
    </button>
  </div>
</template>

<script>
import Label from "./label";
import NewLabel from "./new_label";

export default {
  props: ["labels"],

  data: function() {
    return {
      allLabels: this.labels,
      labelsOpen: false
    };
  },

  mounted: function() {
    window.addEventListener("keydown", e => {
      if (e.key == "Escape") {
        this.labelsOpen = false;
      }
    });
  },

  components: {
    Label,
    NewLabel
  },

  methods: {
    addLabel(label) {
      this.$emit("createdLabel", label);
    },

    removeLabel(label) {
      this.$emit("destroyedLabel", label);
    },

    updateLabel(label) {
      this.$emit("updatedLabel", label);
    }
  }
};
</script>

<style scoped>
/* Transitions are now in the global drawer styles */
</style>
